
import { Component, Prop, Vue } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import StaticItem from '@/components/busi/staticitem.vue'
import { orderFeesChangeDetail } from '@/api/ordercenter'
@Component({
  name: 'OrderFeesChangeDetail',
  components: {
    SimpleTable,
    StaticItem
  }
})
export default class extends Vue {
  @Prop({ type: Number }) private id!: number;

  @Prop({ default: false }) private visible!: boolean;

  private activeNames = ['2']

  private changeInfo: any = {}

  private amountFormat (num: number) {
    return Number(num.toFixed(2))
  }

  private loading = !1

  private async onQuery () {
    this.loading = !0
    await orderFeesChangeDetail({
      id: this.id
    }).then((res: any) => {
      this.changeInfo = res.object.info
      this.changeInfo.changeAmount = this.changeInfo.changeAmount / 100
      this.changeInfo.unChangeAmount = this.changeInfo.unChangeAmount / 100
      this.changeInfo.items = res.object.info.items.map((v: any) => {
        v.arrearsAmount = v.arrearsAmount / 100
        v.payAmount = v.payAmount / 100
        v.receivableAmount = v.receivableAmount / 100
        v.reductionAmount = v.reductionAmount / 100
        return v
      })
      this.changeInfo.unChangeItems = res.object.info.unChangeItems.map((v: any) => {
        v.amount = v.amount / 100
        v.payAmount = v.payAmount / 100
        v.refundAmount = v.refundAmount / 100
        v.reductionAmount = v.reductionAmount / 100
        v.settleAmount = v.settleAmount / 100
        v.unChangeAmount = v.unChangeAmount / 100
        return v
      })
      this.changeInfo.payAmount = this.changeInfo.payAmount / 100
      this.changeInfo.reductionAmount = this.changeInfo.reductionAmount / 100
      this.changeInfo.accountAmount = this.changeInfo.accountAmount / 100
      this.changeInfo.arrearsAmount = this.changeInfo.arrearsAmount / 100
      this.loading = !1
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private setUnChangePayRecordTableColSpan () {
    setTimeout(() => {
      if (document.querySelector('#unChangePayRecordTable')) {
        var current = (document as any)
          .querySelector('#unChangePayRecordTable')
          .querySelector('.el-table__footer-wrapper')
          .querySelector('.el-table__footer')
        var cell = current.rows[0].cells
        cell[0].colSpan = '7'
        cell[1].style.display = 'none'
        cell[2].style.display = 'none'
        cell[3].style.display = 'none'
        cell[4].style.display = 'none'
        cell[5].style.display = 'none'
        cell[6].style.display = 'none'
      }
    }, 50)
  }

  private setAbnormalTurnOperationTableColSpan () {
    setTimeout(() => {
      if (document.querySelector('#abnormalTurnOperationTable')) {
        var current = (document as any)
          .querySelector('#abnormalTurnOperationTable')
          .querySelector('.el-table__footer-wrapper')
          .querySelector('.el-table__footer')
        var cell = current.rows[0].cells
        cell[0].colSpan = '8'
        cell[1].style.display = 'none'
        cell[2].style.display = 'none'
        cell[3].style.display = 'none'
        cell[4].style.display = 'none'
        cell[5].style.display = 'none'
        cell[6].style.display = 'none'
        cell[7].style.display = 'none'
      }
    }, 50)
  }

  private getUnChangePayRecordTableSummaries (param: any) {
    const { columns, data } = param
    const sumsNumber: any = []
    const sums: any = []
    columns.forEach((column: any, index: any) => {
      if (index === 0) {
        sums[index] = '合计'
        return
      }
      const values = data.map((item: any) => Number(item[column.property]))
      if (!values.every((value: any) => isNaN(value))) {
        sums[index] = values.reduce((prev: any, curr: any) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return this.amountFormat(prev + curr)
          } else {
            return prev
          }
        }, 0)
        sumsNumber[index] = values.reduce((prev: any, curr: any) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return this.amountFormat(prev + curr)
          } else {
            return prev
          }
        }, 0)
      } else {
        sums[index] = ''
      }
    })
    return sums
  }

  private getAbnormalTurnOperationTableSummaries (param: any) {
    const { columns, data } = param
    const sumsNumber: any = []
    const sums: any = []
    columns.forEach((column: any, index: any) => {
      if (index === 0) {
        sums[index] = '合计（勾选项）'
        return
      }
      const values = data.map((item: any) => Number(item[column.property]))
      if (!values.every((value: any) => isNaN(value))) {
        sums[index] = values.reduce((prev: any, curr: any) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return this.amountFormat(prev + curr)
          } else {
            return prev
          }
        }, 0)
        sumsNumber[index] = values.reduce((prev: any, curr: any) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return this.amountFormat(prev + curr)
          } else {
            return prev
          }
        }, 0)
      } else {
        sums[index] = ''
      }
    })
    return sums
  }

  private clear () {
    this.activeNames = ['2']
    this.changeInfo = {}
  }

  private onClose () {
    this.clear()
    this.$emit('update:visible', false)
  }

  public open (): void {
    this.onQuery()
    this.setUnChangePayRecordTableColSpan()
    this.setAbnormalTurnOperationTableColSpan()
  }
}
